import { Box, Fab } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useEffect, useState } from "react";

export default function FloatingActions() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* WHATSAPP */}
      <Box
        sx={{
          position: "fixed",
          bottom: { xs: 20, md: 28 },
          left: { xs: 16, md: 28 },
          zIndex: 1200,
        }}
      >
        <Fab
          component="a"
          href="https://wa.me/+971547914848?text=Hi%20Vision%20X%2C%20I’d%20like%20to%20discuss%20a%20property."
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            width: 54,
            height: 54,
            backgroundColor: "#25D366",
            color: "#fff",
            boxShadow: "0 14px 35px rgba(0,0,0,0.45)",
            transition: "all 0.3s ease",

            "&:hover": {
              transform: "translateY(-3px)",
              boxShadow: "0 22px 45px rgba(0,0,0,0.6)",
              backgroundColor: "#1ebe5d",
            },
          }}
        >
          <WhatsAppIcon sx={{ fontSize: 26 }} />
        </Fab>
      </Box>

      {/* BACK TO TOP */}
      {showTop && (
        <Box
          sx={{
            position: "fixed",
            bottom: { xs: 20, md: 28 },
            right: { xs: 16, md: 28 },
            zIndex: 1200,
          }}
        >
          <Fab
            onClick={scrollToTop}
            sx={{
              width: 52,
              height: 52,
              background: "linear-gradient(180deg, var(--color-gold), #b9964a)",
              color: "var(--color-primary-dark)",
              boxShadow: "0 14px 35px rgba(0,0,0,0.45)",
              transition: "all 0.3s ease",

              "&:hover": {
                transform: "translateY(-3px)",
                boxShadow: "0 22px 45px rgba(0,0,0,0.6)",
              },
            }}
          >
            <KeyboardArrowUpIcon sx={{ fontSize: 28 }} />
          </Fab>
        </Box>
      )}
    </>
  );
}
